/**
 * Form Component System - Composable forms with config-driven rendering
 *
 * Usage:
 *   <Form schema={schema} defaultValues={{}} onSubmit={onSubmit}>
 *     <Form.Fields fields={FORM_FIELDS} layout="auto-grid" />
 *     <Form.Actions>
 *       <Form.SubmitButton label="Create" requiredFields={['name', 'email']} />
 *     </Form.Actions>
 *   </Form>
 */

import { Form as FormProvider } from './FormProvider';
import { FormField } from './FormField';
import { FormFields } from './FormFields';
import { FormFieldRow } from './FormFieldRow';
import { FormActions } from './FormActions';
import { FormSubmitButton } from './FormSubmitButton';

const Form = Object.assign(FormProvider, {
  Field: FormField,
  Fields: FormFields,
  FieldRow: FormFieldRow,
  Actions: FormActions,
  SubmitButton: FormSubmitButton,
});

export { Form };
export { shouldShowFieldError, useFieldErrorVisibility } from './fieldErrorVisibility';
export type { FormFieldConfig } from '../common/forms/FormField';
